import _Message from "@arco-design/web-react/es/Message";
import _Popover from "@arco-design/web-react/es/Popover";
import _Grid from "@arco-design/web-react/es/Grid";
import _Radio from "@arco-design/web-react/es/Radio";
import _Form from "@arco-design/web-react/es/Form";
import _Modal from "@arco-design/web-react/es/Modal";
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import React, { useState } from 'react';
import { CreateThemeByThemeId } from '@api/theme';
import ThemeForm from '../themeCreate/themeForm';
import IconCopyTheme from '@src/assets/svg/copy-theme.svg';
import IconForkTheme from '@src/assets/svg/fork-theme.svg';
import IconFormThemeChecked from '@src/assets/svg/fork-theme-checked.svg';
import { IconInfoCircleFill } from '@arco-design/web-react/icon';
import style from './style.less';
import { formatDesignPageUrl } from '@src/utils/hooks/useBreadcrumb';
import locale from './locale';
import { themeOperate } from '@src/utils/constants';
var CopyTheme = function CopyTheme(props) {
  var theme = props.theme,
    disabled = props.disabled;
  var _a = __read(useState(false), 2),
    visible = _a[0],
    setVisible = _a[1];
  var t = locale[props.lang || 'zh-CN'] || locale['zh-CN'];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    onClick: function onClick() {
      !disabled && setVisible(true);
    }
  }, props.children), visible ? /*#__PURE__*/React.createElement(_Modal, {
    visible: true,
    title: t.copy,
    style: {
      width: 531
    },
    footer: null,
    onCancel: function onCancel() {
      setVisible(false);
    }
  }, /*#__PURE__*/React.createElement(ThemeForm, {
    lang: props.lang,
    header: theme.canCopy ? /*#__PURE__*/React.createElement(_Form.Item, {
      label: t.extendType,
      field: "extendType",
      rules: [{
        required: true
      }],
      shouldUpdate: true
    }, function (values) {
      return /*#__PURE__*/React.createElement(_Radio.Group, null, /*#__PURE__*/React.createElement(_Radio, {
        value: "copy",
        style: {
          margin: 0,
          width: '100%',
          marginBottom: 12
        }
      }, function (_a) {
        var checked = _a.checked;
        return /*#__PURE__*/React.createElement(_Grid.Row, {
          justify: "space-between",
          className: [style['radio'], checked ? style['radio-checked'] : '']
        }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, t.copy), /*#__PURE__*/React.createElement("div", {
          className: style['radio-desc']
        }, t.copyDesc)), /*#__PURE__*/React.createElement(IconCopyTheme, null));
      }), theme.allowFork && /*#__PURE__*/React.createElement(_Popover, {
        disabled: values.canFork,
        content: t.disabledTip
      }, /*#__PURE__*/React.createElement(_Radio, {
        value: "fork",
        style: {
          width: '100%'
        },
        disabled: !values.canFork
      }, function (_a) {
        var checked = _a.checked;
        return /*#__PURE__*/React.createElement(_Grid.Row, {
          justify: "space-between",
          className: [style['radio'], checked ? style['radio-checked'] : '', !values.canFork ? style['radio-disabled'] : '']
        }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, t.fork), /*#__PURE__*/React.createElement("div", {
          className: style['radio-desc']
        }, t.forkDesc, /*#__PURE__*/React.createElement(_Popover, {
          content: t.forkTip
        }, /*#__PURE__*/React.createElement(IconInfoCircleFill, null)))), checked ? /*#__PURE__*/React.createElement(IconFormThemeChecked, null) : /*#__PURE__*/React.createElement(IconForkTheme, null));
      })));
    }) : null,
    initialValue: __assign(__assign({}, theme), {
      extendType: 'copy'
    }),
    onSubmit: function onSubmit(values) {
      return __awaiter(void 0, void 0, void 0, function () {
        var newTheme;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4, CreateThemeByThemeId(__assign(__assign({}, values), {
                themeId: theme.themeId
              }))];
            case 1:
              newTheme = _a.sent();
              _Message.success('success');
              location.href = formatDesignPageUrl(newTheme.themeId);
              return [2];
          }
        });
      });
    },
    onCancel: function onCancel() {
      setVisible(false);
    },
    operate: themeOperate.copy
  })) : null);
};
export default CopyTheme;